(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scroll-top]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var card = document.getElementById('sticky-blog-cart');
    var trigger = document.getElementById('sticky-blog-cart-trigger');
    if (!card || !trigger) return;

    var STORAGE_KEY = 'vps-sticky-blog-cart-dismissed';
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        card.remove();
        return;
      }
    } catch (e) {}

    card.hidden = false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          card.setAttribute('data-visible', 'true');
        } else {
          card.removeAttribute('data-visible');
        }
      });
    }, { rootMargin: '0px 0px -85% 0px' });
    observer.observe(trigger);

    var btn = card.querySelector('[data-sticky-dismiss]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        card.removeAttribute('data-visible');
        try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e2) {}
        setTimeout(function () { card.remove(); }, 280);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var input = document.getElementById('faq-search');
    if (!input) return;
    var items = document.querySelectorAll('.faq__item');
    var categories = document.querySelectorAll('.faq__category');

    function filter() {
      var q = input.value.trim().toLowerCase();
      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        if (!q || text.indexOf(q) !== -1) {
          item.classList.remove('faq__item--hidden');
        } else {
          item.classList.add('faq__item--hidden');
        }
      });
      // Hide a category if all sibling questions until the next category are hidden
      categories.forEach(function (cat) {
        var sib = cat.nextElementSibling;
        var anyVisible = false;
        while (sib && !sib.classList.contains('faq__category')) {
          if (sib.classList.contains('faq__item') && !sib.classList.contains('faq__item--hidden')) {
            anyVisible = true;
            break;
          }
          sib = sib.nextElementSibling;
        }
        cat.style.display = anyVisible || !q ? '' : 'none';
      });
    }

    input.addEventListener('input', filter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.science-ing__body a[href^="http"]').forEach(function(a){
    a.target = '_blank';
    a.rel = 'noopener';
  });

  } catch(e) { console.error(e); }
})();
})();
